import React from 'react';

import SectionLayout from 'dpl/quiz/components/SectionLayout';
import { SECTION_CLASSES } from 'dpl/quiz/sections/components/Section';

export default function PaymentPolicyAttestation(props) {
  return (
    <div className={SECTION_CLASSES}>
      <div className="FullPageQuizQuestion tc">
        <h3 className="f4 fw-medium f5-md lh-title mb8">
          Review our secure payment policy
        </h3>
        <p className="secondary font-16-mobile mb4 mb14-md">
          For your safety during your puppy search, our Terms of Service require
          all payments to be processed through Good Dog&apos;s secure payment
          system.
          <br />
          <br />
          Always pay through Good Dog. Paying a breeder directly voids your
          Payment Protection and leaves you without support if issues arise.
        </p>
        <SectionLayout {...props} />
      </div>
    </div>
  );
}
